import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OCUPACIONES, PERSONAS_DOMICILIO } from './data/step-two-one';

@Component({
  selector: 'app-step-two-one',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-two-one.component.html',
  styleUrls: ['./step-two-one.component.scss']
})
export class StepTwoOneComponent {
  ocupaciones = OCUPACIONES;
  personasDomicilio = PERSONAS_DOMICILIO;
} 